import {CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {AutoFocusInputDirective} from './directives';

import { OrderByPipe, SafeHtmlPipe, TrustedResourceUrlPipe, TrustedStylePipe } from './pipes';
import { ToNameImage } from './pipes/to-name-image.pipe';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { SuccessModalComponent } from './components/success-modal/success-modal.component';
import { AttentionModalComponent } from './components/attention-modal/attention-modal.component';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { DocumentPreviewComponent } from './components/document-preview/document-preview.component';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { BadgetsComponent } from './components/badges.component';
import { MatchTypeReportPipe } from './pipes/match-type-report.pipe';
import { ConfidencePipe, ConfidenceClassPipe } from './pipes/confidence.pipe';
import { DateFilterComponent } from './components/date-filter/date-filter.component';
import { IcArrowComponent } from './components/svg/ic-arrow.component';
import { SideNavInnerToolbarComponent, SideNavOuterToolbarComponent, SingleCardComponent } from './layouts';
import { FooterComponent, HeaderComponent, SideNavigationMenuComponent, ThemeSwitcherComponent, UserPanelComponent } from './components';
import { PopupContainerComponent } from './components/popup-container/popup-container.component';
import { DashboardBarChartTitlePipe } from './pipes/dashboard-bar-chart-title.pipe';
import { LocalDatetimePipe } from './pipes/local-datetime.pipe';
import { LocalDatePipe } from './pipes/local-date.pipe';
import { SpecificationModule } from 'specification/specification.module';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { FeedbackWidgetComponent } from './components/feedback-widget/feedback-widget.component';
import { TextAreaHistoricalComponent } from './components/text-area-historical/text-area-historical.component';
import { FileNamePipe } from './pipes/file-name.pipe';
import { ResolveExtractionErrorPopupComponent } from './components/resolve-extraction-error-popup/resolve-extraction-error-popup.component';
import { SzTableComponent } from './components/sz-table/sz-table.component';
import { MetricCardComponent } from './components/metric-card/metric-card.component';
import { SzModalComponent } from './components/sz-modal/sz-modal.component';
import { SzEditorComponent } from './components/sz-editor/sz-editor.component';

const BASE_MODULES = [
  CommonModule,
  RouterModule,
  FormsModule,
  SpecificationModule,
  ReactiveFormsModule
];

const PROVIDERS = [
  Location,
  { provide: LocationStrategy, useClass: PathLocationStrategy },
];
const DIRECTIVES = [
  AutoFocusInputDirective
];

const PIPES = [
  SafeHtmlPipe,
  OrderByPipe,
  TrustedStylePipe,
  TrustedResourceUrlPipe,
  ToNameImage,
  FileNamePipe,
  TimeAgoPipe,
  MatchTypeReportPipe,
  ConfidencePipe,
  ConfidenceClassPipe,
  DashboardBarChartTitlePipe,
  LocalDatetimePipe,
  LocalDatePipe
];

const COMPONENTS = [
  ConfirmModalComponent,
  SuccessModalComponent,
  AttentionModalComponent,
  SearchBarComponent,
  DocumentPreviewComponent,
  FileUploadComponent,
  BadgetsComponent,
  DateFilterComponent,
  IcArrowComponent,
  SingleCardComponent,
  SideNavInnerToolbarComponent,
  SideNavOuterToolbarComponent,
  HeaderComponent,
  FooterComponent,
  PopupContainerComponent,
  SideNavigationMenuComponent,
  ThemeSwitcherComponent,
  UserPanelComponent,
  TooltipComponent,
  FeedbackWidgetComponent,
  TextAreaHistoricalComponent,
  ResolveExtractionErrorPopupComponent
];

@NgModule({
  imports: [
    ...BASE_MODULES,
    SzTableComponent,
    MetricCardComponent,
    SzModalComponent,
    SzEditorComponent,
  ],
  declarations: [
    ...DIRECTIVES,
    ...COMPONENTS,
    ...PIPES,
  ],
  exports: [
    ...BASE_MODULES,
    ...DIRECTIVES,
    ...PIPES,
    ...COMPONENTS,
    SzTableComponent,
    MetricCardComponent,
    SzModalComponent,
    SzEditorComponent,
  ],
  providers: [
    ...PROVIDERS,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [...PROVIDERS],
    };
  }
}
